module.exports = __webpack_public_path__ + "static/media/supplier.2ce98fec.svg";